import React from "react";
import { Input, Select, Button, Space, DatePicker, Row, Col, Dropdown, Checkbox, Modal, Tooltip, Image } from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { PlusOutlined, DownOutlined, EyeOutlined } from "@ant-design/icons";
import withRouter from "../withRouter";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import VehicleStore from "../store/VehicleStore";
import AiAlarmReportStore from "../store/AiAlarmReportStore";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import { decode as base64_decode, encode as base64_encode } from 'base-64';
import Cookies from "js-cookie";

const { RangePicker } = DatePicker;

dayjs.extend(customParseFormat);
const { Option } = Select;
class AiAlarmReport extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.AiAlarmReportStore = new AiAlarmReportStore();

    this.vehicleStore = new VehicleStore(this);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      company_name: "",
      listUpdated: 0,
      companyId: "",
      fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      toDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      selectedVehicles: [],
      selectAllVehicles: false,
      selectAllAlarms: false,
      modalVisible: false,
      column: "",
      filter: "",
      Notcompany: false,
      Notasset: false,
      Notalarm: false,
      evidenceVisible: false,
      selectedRecord: null,
      showimg: false,
      modalContent: null,
      selectedColumns: [
        {
          title: context.translate("_FLEET_DASHBORD_RULETRIGGER_VEHICLE_"),
          dataIndex: "vehicleNo",
          key: "vehicleNo",
          width: "15%",
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_DRIVER_NAME_"),
          dataIndex: "driverName",
          key: "driverName",
          width: "15%",
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_ALARM_TYPE_"),
          dataIndex: "alarmName",
          key: "alarmName",
          width: "15%",
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_LOCATION_TIME_"),
          dataIndex: "timestamp",
          key: "timestamp",
          width: "15%",
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_START_TIME_"),
          dataIndex: "st",
          key: "st",
          width: "15%",
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_END_TIME_"),
          dataIndex: "et",
          key: "et",
          width: "15%",
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_LOCATION_"),
          dataIndex: "location",
          key: "location",
          width: "15%",
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_SPEED_"),
          dataIndex: "speed",
          key: "speed",
          width: "15%",
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_DETAILS_"),
          dataIndex: "alarmString",
          key: "alarmString",
          width: "15%",
          ellipsis: { showTitle: true },
          render: (alarmString) => (
            <Tooltip placement="topLeft" title={alarmString}>
              <div>{alarmString}</div>
            </Tooltip>
          )
        },
        {
          title: context.translate("_ACTION_"),
          dataIndex: "Action",
          width: "9%",
          align: "center",
          ellipsis: {
            showTitle: true,
          },
          render: (_, record) => {
            return (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Tooltip title={context.translate("_VIEW_")}>
                  <EyeOutlined
                    style={{ cursor: "pointer", fontSize: "16px", color: "#1890ff" }}
                    onClick={() => {
                      console.log(record);
                      if (record.MDVR == "H-Protocol") {
                        this.showEvidence(record)
                      } else {
                        this.getEvidence(record);
                      }
                    }
                    }
                  />
                </Tooltip>
              </div>
            );
          },
        }
      ],
    };
    this.ExportMenuProps = {
      items: [
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={Excel}
              ></Image>
              {context.translate("_EXPORT_AS_EXCEL_")}
            </div>
          ),
          key: "excel",
        },
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={PDF}
              ></Image>
              {context.translate("_EXPORT_AS_PDF_")}
            </div>
          ),
          key: "pdf",
        },
      ],
      onClick: (val) => {
        let result = [];
        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));
          var getData = {
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles,
            alarmId: this.state.selectedAlarms,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            colList: result.toString(),
            userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
          };
          console.log(getData);
          if (val.key == "excel") {
            // console.log("afd")
            this.AiAlarmReportStore.exportExcel(getData);
          }
          if (val.key == "pdf") {
            this.AiAlarmReportStore.exportpdf(getData);
          }

        }



      },
    };
    this.newColumns = [...this.state.selectedColumns];
  }

  async componentDidMount() {
    this.setState({ pageSize: 50 });
    await this.AiAlarmReportStore.getAlarms();
    await this.setState({ column: this.state.selectedColumns });

    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;

      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }
  }

  async handleTableChange(pagination, filters, sorter) {
    //   console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({ Notcompany: false });
    await this.vehicleStore.getVehiclesCompanyId(comp?.value);
    await this.AiAlarmReportStore.getAlarms();
    await this.setState({ selectedVehicles: [], selectAllVehicles: false });
    await this.setState({ currentPage: 1, companyId: comp?.value });

    // this.handleSearch();
  }


  async handleSearch() {
    this.setState({ Notasset: false });
    this.setState({ Notalarm: false });
    await this.AiAlarmReportStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
      vehicleId: this.state.selectedVehicles,
      alarmId: this.state.selectedAlarms,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
    });

    await this.setState({ listUpdated: 1 }); //need to reload data
  }
  onDateTimeChange = (dates) => {
    if (dates) {
      const format = "YYYY-MM-DD HH:mm:ss";
      this.setState({
        fromDate: dates[0]?.format(format),
        toDate: dates[1]?.format(format),
      });
    }
  };

  showData = async () => {
    if (!this.state.companyId) {
      this.setState({ Notcompany: true });
    } else {
      this.setState({ Notcompany: false });
    }
    if (this.state.selectedVehicles.length === 0) {
      this.setState({ Notasset: true });
    } else {
      this.setState({ Notasset: false });
    }
    if (this.state.selectedAlarms.length === 0) {
      this.setState({ Notalarm: true });
    } else {
      this.setState({ Notalarm: false });
    }
    if (this.state.companyId && this.state.selectedVehicles.length > 0) {
      // this.setState({mandatory:false})
      this.setState({ Notcompany: false, Notasset: false, Notalarm: false });
      await this.AiAlarmReportStore.loadData({
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,
        companyId: this.state.companyId,
        vehicleId: this.state.selectedVehicles,
        alarmId: this.state.selectedAlarms,
        fromDate: this.state.fromDate,
        toDate: this.state.toDate,
      });
      this.setState({ listUpdated: 1 });
      // console.log(this.state.fromDate,this.state.toDate,)
    }
  };
  handleAllSelectVehicles = async (e) => {
    if (this.state.selectAllVehicles) {
      const allVehicles = this.vehicleStore?.getVehiclesUsingCompanyId.map(
        (val) => {
          return val.vehicleId;
        }
      );
      await this.setState({ selectedVehicles: allVehicles });
    } else {
      await this.setState({ selectedVehicles: [] });
    }
  };
  handleAllSelectAlarms = async (e) => {
    if (this.state.selectAllAlarms) {
      const allAlarms = this.AiAlarmReportStore?.alarmlist.map(
        (val) => {
          return val.alarmId;
        }
      );
      await this.setState({ selectedAlarms: allAlarms });
    } else {
      await this.setState({ selectedAlarms: [] });
    }
  };
  handleCheckboxChange = async (column) => {
    console.log(column);
    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );
      console.log(filtered);
      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
      // await  this.updateVisibleColumns();
    } else {
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
      // await  this.updateVisibleColumns();
    }
  };
  showEvidence = (rec) => {

    const hasChannelData =
      rec?.chl1 === 1 || rec?.chl2 === 1 || rec?.chl3 === 1 || rec?.chl4 === 1;

    if (!hasChannelData) {
      Modal.warning({
        title: this.context.translate("_FLEET_ALERT_"),
        content: this.context.translate("_NO_DATA_"),
        style: {
          padding: "20px",
          borderRadius: "10px",
        },
      });
      return;
    }


    this.setState({
      selectedRecord: rec,
      evidenceVisible: true,
    });

  }
  handleCloseEvidence = () => {
    this.setState({
      evidenceVisible: false,
      selectedRecord: null,
    });
  };

  renderEvidenceContent = () => {
    const { selectedRecord: rec } = this.state;
    if (!rec) return null;
    const items = [];
    if (rec.chl1 === 1 || rec.chl2 === 1 || rec.chl3 === 1 || rec.chl4 === 1) {

      // Info block
      items.push(
        <div className="alert-info-block" key="info" style={{ marginBottom: 20 }}>
          <p><b>{this.context.translate("_VEHICLE_NO_")} :</b> {rec.vehicleNo}</p>
          <p><b>{this.context.translate("_FLEET_START_TIME_")} :</b> {rec.st}</p>
          <p><b>{this.context.translate("_FLEET_STOP_TIME_")} :</b> {rec.et}</p>
        </div>
      );
      // rec.chl1 = rec.chl2  =1

      // Image + Video blocks
      for (let i = 1; i <= 4; i++) {
        if (rec[`chl${i}`] === 1) {
          var session = rec.sessionNo;
          var videoUrl = "https://media.trackeazy.com/howendownloaded/test/multimedia#" + session + '-' + i
          // const videoUrl = "https://media.trackeazy.com/howendownloaded/test/multimedia#1749564321-1"; // Add your video URL logic here
          const imageUrl = "https://media.trackeazy.com/howendownloaded/image/" + session + '-' + i + "-snap";
          console.log(videoUrl)
          console.log(imageUrl)
          items.push(
            <b>Channel {i}:</b>
          )
          items.push(

            <div
              key={`chl${i}`}
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "16px",
                marginBottom: "20px",
                justifyContent: "flex-start",
              }}
            >

              <img
                src={imageUrl}
                alt={`Channel ${i}`}
                width={370}
                height={360}
                style={{ objectFit: "cover", border: "1px solid #ccc" }}
              />

              <iframe
                src={videoUrl} // fallback
                width={370}
                height={360}
                title={`Video ${i}`}

              />
            </div>
          );

        }
      }
    } else {

      items.push(
        <div className="alert-info-block" key="info" style={{ marginBottom: 20 }}>
          <p>No Data</p>
        </div>
      )
    }


    return items;
  };
  getEvidence = async (rec) => {
    const data = { vehicleId: rec.vehicleId, companyId: rec.companyId };
    const response = await this.AiAlarmReportStore.getDevices(data);
    console.log(response)
    if (response.success == "S") {
      this.setState({ selectedRecord: rec }); // Store record for modal title
      this.getImage(rec, response.data.data[0]);
    }
  };
  getImage = async (rec, device) => {
    const postData = [{
      token: device.token,
      conditionName: device.full_imei,
      startTime: rec.data.st,
      alarmName: rec.get("alarmName"),
      alarmTypeId: rec.get("alarmTypeId"),
      endTime: rec.data.et,
    }];

    const res = await this.AiAlarmReportStore.getAIdata(postData);
    if (res.success === "S" && res.data.length > 0) {
      const items2 = [];

      items2.push(
        <div className="alert-info-block" key="info" style={{ marginBottom: 20 }}>
          <p><b>Driver Name :</b> {rec.driverName}</p>
          <p><b>Vehicle No :</b> {rec.vehicleNo}</p>
          <p><b>Start Time :</b> {rec.st}</p>
          <p><b>End Time :</b> {rec.et}</p>
        </div>
      );

      for (let i = 0; i < res.data[0].alarmFile.length; i++) {
        const file = res.data[0].alarmFile[i];

        const baseUrl = device.cmsvssWebHost + (device.LoginServerPort ? `:${device.LoginServerPort}` : "");
        const fileUrl = `${baseUrl}/record/showImage.action?token=${device.token}&scheme=http&fileName=${file.fileThumbnail.replace(" ", "%20")}&deviceID=${device.full_imei}&fileSize=123456&fileType=2`;

        let videoUrl = file.downUrl.replace(/:\d+/, '');

        if (file.fileType == 2) {
          // Video
          items2.push(
            <div key={fileUrl} className="alert-video-block" style={{ width: 400, height: 360, marginBottom: 20 }}>
              <video width="370" height="360" controls>
                <source src={videoUrl} type="video/mp4" />
              </video>
              <div style={{ textAlign: "right", marginTop: 8 }}>
                <button
                  className="blue-download-btn icon-download"
                  onClick={() => window.location.href = videoUrl}
                >
                  Download
                </button>
              </div>
            </div>
          );
        } else {
          // Image
          items2.push(
            <div key={fileUrl}>
              <img
                src={fileUrl}
                width={370}
                height={360}
                style={{ margin: '0 0 20px 0' }}
                alt="Alert"
              />
              <div style={{ textAlign: "right", marginTop: 8 }}>
                <button
                  className="blue-download-btn icon-download"
                  onClick={() => window.location.href = videoUrl}
                >
                  Download
                </button>
              </div>
            </div>
          );
        }
      }

      this.setState({ modalContent: items2, showimg: true });
    }
  };

  refreshList = async () => {
    await this.setState({ loading: false, current: 1, currentPage: 1 });
    await this.showData();
  };
  render() {

    const { evidenceVisible, selectedRecord } = this.state;

    const rec = this.state.selectedRecord;

    const hasChannelData =
      rec && (rec.chl1 === 1 || rec.chl2 === 1 || rec.chl3 === 1 || rec.chl4 === 1);

    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  allowClear={true}
                  onChange={(value) => this.handleChange(value)}
                  style={{ width: 150 }}
                  status={this.state.Notcompany ? "error" : false}
                />

                <Checkbox
                  checked={this.state.selectAllVehicles}
                  onChange={async (e) => {
                    await this.setState({
                      selectAllVehicles: e.target.checked,
                    });
                    if (this.state.selectAllVehicles) {
                      await this.setState({
                        Notasset: false,
                      });
                    }
                    console.log(e.target.checked);
                    await this.handleAllSelectVehicles();
                  }}
                />

                {this.context.translate("_ALL_")}
                {"  "}

                <Select
                  className="searchInput"
                  maxTagCount="responsive"
                  value={this.state.selectedVehicles}
                  onChange={(val) => {
                    this.setState({ selectedVehicles: val });
                    if (
                      this.vehicleStore?.getVehiclesUsingCompanyId.length >
                      val.length
                    ) {
                      this.setState({ selectAllVehicles: false });
                    } else {
                      this.setState({ selectAllVehicles: true });
                    }

                    if (val?.length > 1) {
                      console.log(val?.length > 1);
                      this.setState({ showAlertPopup: true });
                    }
                  }}
                  style={{ width: 200 }}
                  showSearch
                  status={this.state.Notasset ? "error" : false}
                  mode="multiple"
                  placeholder={this.context.translate(
                    "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                  )}
                  filterOption={(inputValue, option) => {
                    if (option.children) {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(inputValue.toLowerCase()) >= 0
                      );
                    }
                  }}
                >
                  {this.vehicleStore?.getVehiclesUsingCompanyId?.map((val) => {
                    return (
                      <Option value={val.vehicleId}>{val.vehicleNo}</Option>
                    );
                  })}
                </Select>
                {/*alarm type combo*/}

                <Checkbox
                  checked={this.state.selectAllAlarms}
                  onChange={async (e) => {
                    await this.setState({ selectAllAlarms: e.target.checked });
                    if (this.state.selectAllAlarms) {
                      await this.setState({
                        Notalarm: false,
                      });
                    }
                    // console.log(e.target.checked);
                    await this.handleAllSelectAlarms();
                  }}
                />
                {/* All */}
                {this.context.translate("_ALL_")}
                {"  "}

                <Select
                  maxTagCount="responsive"
                  className="searchInput"
                  value={this.state.selectedAlarms}
                  onChange={(val) => {
                    this.setState({ selectedAlarms: val });
                    if (
                      this.AiAlarmReportStore?.alarmlist.length >
                      val.length
                    ) {
                      this.setState({ selectAllAlarms: false });
                    } else {
                      this.setState({ selectAllAlarms: true });
                    }

                    if (val?.length > 1) {
                      console.log(val?.length > 1);
                      this.setState({ showAlertPopup: true });
                    }
                  }}
                  style={{ width: 200 }}
                  showSearch
                  status={this.state.Notalarm ? "error" : false}
                  mode="multiple"
                  placeholder={this.context.translate(
                    "_ALARM_TYPE_"
                  )}
                  filterOption={(inputValue, option) => {
                    if (option.children) {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(inputValue.toLowerCase()) >= 0
                      );
                    }
                  }}
                >
                  {this.AiAlarmReportStore?.alarmlist?.map((val) => {
                    return <Option value={val.alarmId}>{val.alarmName}</Option>;
                  })}
                </Select>
                <RangePicker
                  status={this.state.Notdate ? "error" : false}
                  placeholder={["From Datetime", "To Datetime"]}
                  format="DD-MM-YYYY hh:mmA"
                  style={{ width: 400, borderRadius: "25px" }}
                  onChange={(val) => {
                    this.onDateTimeChange(val);
                  }}
                  disabledDate={(current) => {
                    return current && current > dayjs();
                  }}
                  showTime={{
                    format: "h:mmA",
                    defaultValue: [dayjs().startOf("day"), dayjs()],
                  }}
                  defaultValue={[dayjs().startOf("day"), dayjs()]}
                />

                <Button type="primary" onClick={() => this.showData()}>
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                </Button>

                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {this.context.translate("_COLUMNS_")}
                </Button>
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={4}
            >
              <Space>
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>
                <Button
                  className="downloadExcelButton"
                  disabled={
                    this.AiAlarmReportStore?.alarmData?.length > 0
                      ? false
                      : true
                  }
                >
                  <Dropdown
                    overlayClassName="export-dropdown"
                    menu={this.ExportMenuProps}
                  >
                    <Image
                      style={{
                        height: 18,
                        alignItems: "center",
                        marginInlineEnd: "30px",
                      }}
                      src={downloadIcon}
                    ></Image>
                  </Dropdown>
                </Button>
              </Space>
            </Col>
          </Row>

          <Modal
            open={this.state.modalVisible}
            width={250}
            // title="Select Columns"
            title={this.context.translate("_SELECT_COLUMNS_")}
            onCancel={() => this.setState({ modalVisible: false })}
            onOk={() => {
              this.setState({ modalVisible: false });
            }}
            footer={null}
          >
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              {console.log(this.newColumns, "Df")}
              {this.newColumns.map((column, v) => {
                return (
                  <Row key={v}>
                    <Col>
                      <Checkbox
                        onChange={() => this.handleCheckboxChange(column)}
                        checked={this.state.selectedColumns.some(
                          (c) => c.key === column.key
                        )}
                      >
                        {column.title}
                      </Checkbox>
                    </Col>
                  </Row>
                );
              })}
            </div>
          </Modal>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.AiAlarmReportStore?.total}
            columns={this.state.column}
            dataSource={this.AiAlarmReportStore?.alarmData}
            loading={this.AiAlarmReportStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        <Modal
          title={hasChannelData ? `Alert Name: ${selectedRecord?.alarmName || ""}` : "Alert"}
          open={evidenceVisible}
          onCancel={this.handleCloseEvidence}
          footer={null}
          width={hasChannelData ? 800 : 200}
          bodyStyle={{ maxHeight: 550, overflowY: "auto", padding: 10 }}
        >
          {this.renderEvidenceContent()}
        </Modal>

        <Modal
          title={`Alert Name: ${this.state.selectedRecord?.alarmName || ""}`}
          open={this.state.showimg}
          onCancel={() => this.setState({ showimg: false })}
          footer={null}
          width={800}
          bodyStyle={{ maxHeight: 500, overflowY: "auto", padding: 10 }}
        >
          {this.state.modalContent}
        </Modal>

      </>
    );
  }
}
AiAlarmReport.contextType = StoreContext;
export default observer(withRouter(AiAlarmReport));
